import requests from "./httpService";

const WeightagesService = {
  getWeightages(id, body) {
    return requests.get(`/weightages/all?company_id=${id}`, body);
  },
  createWeightages(body) {
    return requests.post(`/weightages/create`, body);
  },
  updateWeightages(id, body) {
    return requests.post(`/weightages/update/${id}`, body);
  },
  deleteWeightages(id, body) {
    return requests.delete(`/weightages/delete/${id}`, body);
  },
  detailWeightages(id, body) {
    return requests.get(`/weightages/details/${id}`, body);
  },
};

export default WeightagesService;
